import { useQuery, UseQueryOptions } from 'react-query';
import { getProductScope } from '@discover-frontend/utils';

import { STANLEY_QUERY_KEYS } from '../constants';
import { fetchStanleyQueryHistoryList } from '../request';
import { StanleyQueryHistoryListResponse } from '../types';

export const useStanleyQueryHistoryList = (
  options?: Omit<
    UseQueryOptions<StanleyQueryHistoryListResponse>,
    'queryKey' | 'queryFn'
  >
) => {
  const scope = getProductScope();

  return useQuery<StanleyQueryHistoryListResponse>(
    [STANLEY_QUERY_KEYS.GET_HISTORY, scope],
    fetchStanleyQueryHistoryList,
    options
  );
};
